<template>
<div class="xin">
    <!-- 面包屑 -->

    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <div class="main">
                <el-button @click="tan()">{{ $t("logs.firewall1_a1") }}</el-button>
                <el-alert :title="$t('logs.firewall1_a1_a1')" type="error" show-icon :closable="false"></el-alert>

            </div>
            <div class="main">
                <el-button @click="tan()">{{ $t("logs.firewall1_a_2") }}</el-button>
                <el-alert :title="$t('logs.firewall1_a1_a2')" type="success" show-icon :closable="false"></el-alert>

            </div>
            <!-- 配置双机热备 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.HASetting1") }}
                </span>

                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 广播地址 -->

                                <td> {{ $t("logs.HASetting3") }}:</td>
                                <td style="display:flex;flex-direction:row">

                                    <el-select v-model="ucast_dev" placeholder class="selece1">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input v-model="ucast_addr" placeholder style="width:170px;margin-left:8px"></el-input>
                                    <el-alert :title="$t('logs.HASetting4')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <tr>

                                <!-- 漂移地址 -->
                                <td>{{ $t("logs.HASetting5") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-select v-model="shift_dev" placeholder class="selece1">

                                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input v-model="shift_addr" placeholder style="width:170px;margin-left:8px"></el-input>

                                    <el-alert :title="$t('logs.HASetting6')" type="warning" show-icon :closable="false"></el-alert>

                                </td>
                            </tr>
                            <tr>
                                <!-- ping地址 -->

                                <td>{{ $t("logs.HASetting7") }}:</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-input v-model="ping_addr" placeholder></el-input>

                                    <el-alert :title="$t('logs.HASetting8')" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                            <tr>
                                <!-- 主节点主机名 -->

                                <td>{{ $t("logs.HASetting9") }}:</td>
                                <td>

                                    <el-input v-model="master_node_name" placeholder></el-input>
                                </td>
                            </tr>
                            <tr>
                                <!-- 从节点主机名 -->

                                <td>{{ $t("logs.HASetting10") }}:</td>
                                <td>

                                    <el-input v-model="slave_node_name" placeholder></el-input>
                                </td>
                            </tr>

                            <tr>
                                <!-- 作为主节点 -->

                                <td>{{ $t("logs.HASetting11") }}:</td>
                                <td style="line-height:48px">

                                    <el-checkbox v-model="as_master_node"></el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend_setting()">{{$t('logs.save_a')}}</el-button>
                                    <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

        </el-tabs>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            as_master_node: '',
            slave_node_name: '',
            master_node_name: '',
            ping_addr: '',
            shift_addr: '',
            shift_dev: '',
            ucast_addr: '',
            ucast_dev: '',
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "eth1"
                },
                {
                    value: "选项2",
                    label: "eth2"
                },
                {
                    value: "选项3",
                    label: "eth3"
                }
            ],
            checked: "",
            radio: "1"
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        // 显示
        tan: function () {
            alert("启动HA双机设备，请确定主备机配置正常，并正常连接，确定启动？");
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 默认全局策略加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_network",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        // this.byad = res.data.ret.result.USE_AD_AUTH == 0 ? this.bypop = false : true

                        this.ipaddr = res.data.ret.result.IPADDR

                        this.netmask = res.data.ret.result.NETMASK
                        this.gateway = res.data.ret.result.GATEWAY
                        this.dns1 = res.data.ret.result.DNS1
                        this.dns2 = res.data.ret.result.DNS2
                        this.network = res.data.ret.result.LDAP_PASSWORD
                        this.data_loadok_setting = res.data.ret.ok
                        // this.fileList6 = res.data.ret.datalist;
                        // this.tls_typee = res.data.ret.q_tls_type

                        // 

                    }
                })
               
        },
        // 默认全局策略保存
        tanSend_setting() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_ad_auth",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                dns2: this.dns2,
                network: this.network,
                dns1: this.dns1,
                gateway: this.gateway,
                netmask: this.netmask,
                ipaddr: this.ipaddr,

                data_loadok: this.data_loadok_setting

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
    }
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";

@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 16px;
}

/deep/ .el-select {
    width: 100px;

    .el-input {
        width: 100px;
    }
}

.el-alert--error.is-light {

    font-family: PingFangSC-Regular, PingFang SC;
    color: #F23434;
    background: rgba(242, 52, 52, 0.15);
}

.el-alert--success.is-light {

    background: rgba(35, 149, 71, 0.15);
    font-family: PingFangSC-Regular, PingFang SC;
    color: #1DA254;
}
</style>
